import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { orderBy as _orderBy, partition as _partition } from 'lodash-es';

import { NoteDetails, NoteTarget } from 'generated/graphql';

@Component({
  selector: 'app-view-notes',
  templateUrl: './view-notes.component.html',
  styleUrls: ['./view-notes.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ViewNotesComponent {
  @Input() notes: NoteDetails.Fragment[];
  @Input() noteCampaignId: string;
  @Input() targetId: string;
  @Input() targetType: NoteTarget;
  @Input() preventEdit: boolean;
  @Input() showNoResultsMsg = false;

  noteMarkedForEdit = null;

  get campaignId() {
    return this.route.snapshot.queryParamMap.get('campaignId');
  }

  get sortedNotes() {
    const splitByPinStatus = _partition(this.notes, 'pinnedAt');
    const pinnedNotes = _orderBy(splitByPinStatus[0], ['pinnedAt'], ['desc']) || [];
    const nonPinnedNotes = _orderBy(splitByPinStatus[1], ['createdAt', 'updatedAt'], ['desc', 'desc']) || [];
    this.notes = [...pinnedNotes, ...nonPinnedNotes];
    return this.notes;
  }

  constructor(
    private route: ActivatedRoute
  ) {
  }
}
